import React from 'react'
import ReactDOM from 'react-dom'
import Root from './components/Root'
import { Provider } from 'react-redux'
import configureStore from './configureStore'
import Raven from 'raven-js'

Raven.config('https://4a89e57d0d34461aa575d5ba5ecce92e@sentry.io/237764').install();
const store = configureStore()

ReactDOM.render((
  <Provider store={store}>
    <Root />
  </Provider>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js